const PaperSize = [
  {
    text: "Client",
    value: "Client",
  },
  {
    text: "A3",
    value: "A3",
  },
  {
    text: "A4",
    value: "A4",
  },
  {
    text: "A5",
    value: "A5",
  },
  {
    text: "A6",
    value: "A6",
  },
  {
    text: "Letter",
    value: "Letter",
  },
  {
    text: "Legal",
    value: "Legal",
  },
  {
    text: "Tabloid",
    value: "Tabloid",
  }
];

const ColorPrinting = [
  {
    text: "Client",
    value: "Client",
  },
  {
    text: "RGB",
    value: "Color",
  },
  {
    text: "Grayscale",
    value: "Grayscale",
  }
];

const Border = [
  {
    text: "Client",
    value: "Client",
  },
  {
    text: "White",
    value: "White",
  },
  {
    text: "Black",
    value: "Black",
  }
];

const EmptyImage = [
  {
    text: "Client",
    value: "Client",
  },
  {
    text: "White",
    value: "White",
  },
  {
    text: "Black",
    value: "Black",
  }
];

const Destination = [
  {
    text: "PaperPrinter",
    value: "PaperPrinter",
  },
  {
    text: "LocalStorage",
    value: "LocalStorage",
  }
];

module.exports = {
  paperSize: PaperSize,
  colorPrinting: ColorPrinting,
  border: Border,
  emptyImage: EmptyImage,
  destination: Destination,
};
